var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ons-navigator',{class:{ 'border-radius': _vm.borderRadius },attrs:{"swipeable":"","swipe-target-width":"50px","page-stack":_vm.pageStack,"pop-page":_vm.storePop,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }